<template>
  <div>
    <div class="row">
      <div class="col-3">
        <div class="card card-primary card-outline">
          <div class="card-body box-profile">
            <h3 class="profile-username text-center">
              {{ customer.name.toUpperCase() }}
              {{ customer.secondName.toUpperCase() }}
              {{ customer.surname.toUpperCase() }}
            </h3>

            <p class="text-muted text-center">Müşteri Bilgileri</p>

            <ul class="list-group list-group-unbordered mb-3">
              <li class="list-group-item">
                <b>Müşteri ID</b>
                <a class="float-right">{{ customer.code }}</a>
              </li>
              <li class="list-group-item">
                <b>Kullanıcı Adı</b>
                <a class="float-right">{{ customer.username }}</a>
              </li>
              <li class="list-group-item">
                <b>Tc Kimlik Numarası</b>
                <a class="float-right">{{ customer.tckn }}</a>
              </li>
              <li
                class="list-group-item"
                v-if="auth.GsmInfoSetting != null && auth.GsmInfoSetting.isRead"
              >
                <b>Gsm</b> <a class="float-right">{{ customer.phone | Phone }}</a>
              </li>
              <li class="list-group-item">
                <b>Mail Adresi</b>
                <a class="float-right">{{ customer.mail }}</a>
              </li>
              <li class="list-group-item">
                <b>Doğum Tarihi</b>
                <a class="float-right">{{
                  customer.birthDate | DateFormatBirthDate
                }}</a>
              </li>
              <li class="list-group-item">
                <b>Hesap Durumu</b>
                <a class="float-right">{{ customer.statu }}</a>
              </li>
              <li class="list-group-item">
                <b>Affilate Kodu</b>
                <a class="float-right">{{ customer.affilate }}</a>
              </li>
              <li class="list-group-item">
                <b>Üye Olduğu Tarih</b>
                <a class="float-right">{{
                  customer.registerDate | DateFormat
                }}</a>
              </li>
              <li class="list-group-item">
                <b>Sisteme Kayıt Tarihi</b>
                <a class="float-right">{{ customer.addDate | DateFormat }}</a>
              </li>
              <li class="list-group-item">
                <b>Son Güncellenme Tarihi</b>
                <a class="float-right">{{ customer.justDate | DateFormat }}</a>
              </li>
            </ul>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <div class="col-12">
            <customer-quick :customer="customer"></customer-quick>
          </div>
          <div class="col-6">
            <customer-last-10-request
              :code="customer.code"
            ></customer-last-10-request>
          </div>
          <div class="col-6">
            <customer-last-10-finance
              :code="customer.code"
            ></customer-last-10-finance>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomerLast10Finance from "./CustomerLast10Finance";
import CustomerLast10Request from "./CustomerLast10Request";
import CustomerQuick from "./CustomerQuick";

export default {
  props: ["customer"],
  data() {
    return {
      auth: this.$store.getters.getModules,
    };
  },
  components: {
    CustomerLast10Finance,
    CustomerLast10Request,
    CustomerQuick,
  },
  methods: {},
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
    Phone(value) {
      return value
        .replace(/[^0-9]/g, "")
        .replace(/(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/, "+$1 ($2) $3 $4 $5");
    },
    DateFormatBirthDate(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0];
    },
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerSummary.vue